import { styled } from "@mui/system";
import { Box } from "@mui/material";

export const SignUpPageWrapper = styled(Box)({});
